<template>
  <div class="bonus_modal_box">
    <b-modal
      ref="modal"
      :id="modalId"
      hide-footer
      centered
      title="紅利點數折抵"
      modal-class="discount-modal"
    >
      <Content @handleHide="hide" :index="index" :product="product" :bonusData="bonusData" :bonus-num-modal.sync="bonusNum" :bonusDescription="bonusDescription"/>
    </b-modal>
  </div>
</template>

<script>
import Content from './Content';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      bonusNum: null
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    bonusData: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
     bonusDescription:{
      type:String,
      required:true
    }
  },
  components: {
    Content
  },
  created() {
    this.bonusNum = this.bonusNumFromVuex;
    if (this.bonusNumFromVuex == 0) {
      this.bonusNum = '';
    }
  },
  methods: {
    hide() {
      this.$refs.modal.hide();
    }
  },
  computed: {
    ...mapGetters('cart', ['products']),
    modalId() {
      return 'bonus_modal' + this.index;
    },
    bonusNumFromVuex() {
      return this.products[this.index].bonusDefaultNum;
    }
  }
};
</script>
